module.exports = __webpack_public_path__ + "img/status.f06ebfaa.png";